import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '../../../core/services/loading.service';
import { ProgramService } from '../programs.service';
import { HigTealiumNgxService } from 'hig-tealium-ngx';

@Component({
    selector: 'app-recent-programs',
    templateUrl: './recent-programs.component.html',
    standalone: false
})
export class RecentProgramsComponent {
    recentProgramsData: any;
    recentProgramsDataInitial: any;
    programs: any;
    uniqueItems: any[];
    JSON = JSON;
    constructor(public programService: ProgramService, public loaderService: LoaderService,
        public router: Router, public ngxTealiumService: HigTealiumNgxService
            ) {
                let udo = {
                    site_name: 'TREORiskManagement',
                    page_name: 'Program Home',
                    component_name: 'Program Tab',
                    rmis_email: this.loaderService.getItem('emailID'),
                    rmis_user_id: this.loaderService.getItem('userId')
                };
                ngxTealiumService.updateUDOObject(udo);
    }

    ngOnInit() {
        let payload = {
            "actionType": "PROGRAM_MANAGE",
            "operation": "GET_RECENT_PROGRAMS",
            "organizationId": this.loaderService.getItem('orgId')
        };
        this.programService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                resp.programs = resp.programs.sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime());
                this.recentProgramsData = resp.programs;
                this.programs = JSON.parse(JSON.stringify(resp.programs));
                this.recentProgramsDataInitial = this.recentProgramsData;
                this.recentProgramsDataInitial.forEach(element => {
                    element.products.sort((a, b) => a.shortName?.localeCompare(b.shortName, undefined, { sensitivity: 'base' }));
                });
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });
    }
    showSecondPP = true;
    showThirdLoop = true;
    ngAfterViewInit() {
        let h1 = document.getElementById('firstLoop')?.offsetHeight;
        let h2 = document.getElementById('secondLoop')?.offsetHeight;
        let h3 = document.getElementById('thirdLoop')?.offsetHeight;
        let a = document.getElementById('allPrograms')?.offsetHeight;
        let t = document.getElementById('title')?.offsetHeight;
        let h = document.getElementById('heading')?.offsetHeight;
        if ((541 - (h1 + a + 20 + t + h)) > h2) {
            this.showSecondPP = true;
        } else {
            this.showSecondPP = false;
        }
        if (this.showSecondPP) {
            if ((541 - (h1 + a + 20 + t + h + h2)) > h3) {
                this.showThirdLoop = true;
            } else {
                this.showThirdLoop = false;
            }
        } else {
            this.showThirdLoop = false;
        }
    }

    titleCase(str: string): string {
        return str
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    }
      

    goToAllPrograms() {
        this.loaderService.setItem('allProgramsList', JSON.stringify(this.programs));
        this.router.navigate(['/program/all-programs']);
    }
    goToProgramList(id) {
        this.loaderService.showLoader();
        let payload = {
            "actionType": "PROGRAM_MANAGE",
            "operation": "RETRIEVE_LIST_PROGRAMS",
            "organizationId": this.loaderService.getItem('orgId'),
            "accntPrgrmPrdId": id
        };
        this.programService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.loaderService.setItem('programDetails', JSON.stringify(resp));
                setTimeout(() => {
                    this.router.navigate(['/program/recent-programs-policy-list']);
                }, 0);
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });

    }
}
